import { useState } from 'react'
import { getRandomJoke } from '../api/jokesApi'
import type { Joke } from '../types'

export function HomePage() {
  const [joke, setJoke] = useState<Joke | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleFetchJoke = async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await getRandomJoke()
      
      // SCENARIO 4  - Runtime type error - assuming response shape
      const scenario = import.meta.env.VITE_SCENARIO || window.APP_CONFIG?.scenario
      if (scenario === '4') {
        // Developer assumes response has a 'data' property that is an array
        // but response is actually a single Joke object
        // This causes: "Cannot read property 'map' of undefined" or similar
        // @ts-expect-error - Intentional type mismatch for workshop scenario
        const jokes = response.data.map((j) => j.content)
        console.log('Processed jokes:', jokes)
      }
      
      setJoke(response)
    } catch (err) {
      console.error(err)
      setError('Could not fetch a joke right now. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="page home-page">
      <div className="hero">
        <h1>Wanna hear a joke?</h1>
        <p>Tap the button and we&apos;ll fetch one from the platform jokes vault.</p>
        <button type="button" onClick={handleFetchJoke} disabled={loading} style={{height: '48px'}}>
          {loading ? 'Fetching...' : 'Get Joke'}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {joke && !error && (
        <article className="joke-card" aria-live="polite">
          <p className="joke-content">{joke.content}</p>
          {joke.author && <p className="joke-author">— {joke.author}</p>}
        </article>
      )}
    </section>
  )
}
